import React from "react";
import StyledLinkExpired from "./StylesLinkExpired";
import { Box, Button, Typography } from "@mui/material";
import { BUTTON_LABELS } from "../../constants/lang";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { fetchForgetPassword } from "../../store/reducers/authentication";
import { ToastNotifyError, ToastNotifySuccess } from "../../components/CommonComponents/Toast/ToastNotify";
import { ROUTE_PATH } from "../../constants/route";

const LinkExpired = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { data } = location.state || {};

  const sendResendLink = async () => {
    const dataToSend = {
        email: data,
      };
    try {
      const response = await dispatch(fetchForgetPassword(dataToSend));
      const { status, message } = response?.payload || {};

      if (status) {
        ToastNotifySuccess(message);
        navigate(ROUTE_PATH.FORGET_PASSWORD_CHECK_INBOX, {state: {data}});
      }
    } catch (error) {
      ToastNotifyError("An error occurred. Please try again.");
    }
  };

  return (
    <StyledLinkExpired>
      <Box className="linkexpired-wrap">
        <Box className="linkexpired-header">
          <Box className="circleIcon"></Box>
          <Box className="header">Link expired</Box>
        </Box>
        <Box className="body-wrap">
          <Typography className="body-text">
            Oops! This link has expired. For your security, reset links are
            valid for only 30 minutes.
          </Typography>
        </Box>
        <Box className="button-wrap">
          <Button
            // isLoading={isLoading}
            // disabled={isLoading}
            type="submit"
            variant="contained"
            color="primary"
            className="submit-btn"
            aria-label="submit"
            onClick={() => sendResendLink()}
          >
            {BUTTON_LABELS.REQUEST_NEW_REQUEST_LINK}
          </Button>
          <Box className="spam-folder-text">
            <Typography>
              Didn't receive the email?{" "}
              <span>Check your spam folder or try again</span>
            </Typography>
          </Box>
        </Box>
        <Box className="backLogin" aria-label="login button">
          <Link to="/Login" aria-label="login button">
            {BUTTON_LABELS.BACK_TO_LOGIN}
          </Link>
        </Box>
      </Box>
    </StyledLinkExpired>
  );
};

export default LinkExpired;
